import { Collapse, createStyles, Grid, TextField, Theme, Typography, withStyles, WithStyles } from '@material-ui/core'
import * as React from 'react'
import OutcomeDropDownItem from '../../FormTemplates/CustomOutcomeDropDown/OutcomeDropDownItem'
import FileUploadForm from '../../FileUploadForm/FileUpload'

import { mapToYesOrNoWithNullable } from '../../../services/utils'
import CredentialSection from './CredentialSection/CredentialSection'
// import OutcomeDateItem from 'src/Forms/FormTemplates/CustomOutcomeDate/OutcomeDateItem'
// import moment from 'moment'

interface OtherEnrolledAcademicDetailsProps extends WithStyles<typeof styles> {
	earnedDegreeOrCredit?: boolean | null
	academicCredit: string
	creditsEarned: number | string
	credentialType: string
	handleEarnedDegreeChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
	handleTypeofCreditChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
	handleCreditsEarnedChange: (e: React.ChangeEvent<HTMLInputElement>) => void
	handleTypeOfCredentialChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
  updateDateCredentailAttained:(e:any)=> void
  creditTypeRequired?:boolean
  creditsEarnedRequired?:boolean
  credentialTypeRequired?:boolean
  serviceType?: string
}

const credentialTypes = [
  'Unknown',
	'No recognized credential',
  'Secondary school diploma or equivalency',
  'AA or AS diploma/degree',
  'BA or BS diploma/degree',
  'Occupational licensure',
  'Occupational certificate',
  'Occupational certification',
  'Other recognized diploma, degree, or certificate'
]

const OtherEnrolledAcademicDetails: React.FC<OtherEnrolledAcademicDetailsProps> =
(props: OtherEnrolledAcademicDetailsProps) => {
	const {
		classes,
		earnedDegreeOrCredit,
		academicCredit,
		creditsEarned,
		credentialType,
		handleEarnedDegreeChange,
		handleTypeofCreditChange,
		handleCreditsEarnedChange,
		handleTypeOfCredentialChange,
    serviceType
	} = props

	return (
   
		<div className={classes.root}>
			<Typography variant="h5" className={classes.sectionSubtitle}>
				Credit and Credentials
			</Typography>

			<Grid container={true} spacing={8}>
				<Grid item={true} xs={12}>
					<OutcomeDropDownItem
						label="Earned Academic Degree/Credit"
						prop="earnedDegreeOrCredit"
						value={mapToYesOrNoWithNullable(earnedDegreeOrCredit)}
						onInputChange={handleEarnedDegreeChange}
						items={['Yes', 'No']}
            serviceType={serviceType}
					/>
				</Grid>
			</Grid>
			<Collapse
				in={!!earnedDegreeOrCredit}
				style={{ transformOrigin: '0 0 0', flexGrow: 1 }}
				{...(earnedDegreeOrCredit ? { timeout: 750 } : {})}
			>
				<Grid container={true} spacing={8}>
					<Grid item={true} xs={12}>
						<OutcomeDropDownItem
							label="Type of Credit"
							prop="academicCredit"
							value={academicCredit}
							onInputChange={handleTypeofCreditChange}
							items={['High School Credit', 'College Credit']}
							required={(props.creditTypeRequired === false)? false: !!earnedDegreeOrCredit}
							hideUnknown={true}
						/>
					</Grid>
					<Grid item={true} xs={12} md={3} className={classes.dropdownLabel}>
						Number of credits&#58;
					</Grid>
					<Grid item={true} xs={12} sm={3}>
						<TextField
							required={(props.creditsEarnedRequired === false)? false: !!earnedDegreeOrCredit}
							name="creditsEarned"
							className={classes.dropdown}
							value={creditsEarned}
							onChange={handleCreditsEarnedChange}
							margin="dense"
							variant="outlined"
							InputProps={{
								inputProps: {
									type: 'number',
									min: '0',
									step: 'any',
								},
							}}
						/>
					</Grid>
				</Grid>
			</Collapse>
			<Grid className={classes.block} container={true} spacing={8}>
        <CredentialSection
          credentialTypeRequired={props.credentialTypeRequired }
          index={1}
        />
        <CredentialSection
          credentialTypeRequired={props.credentialTypeRequired }
          index={2}
        />
			</Grid>
		</div>
	)
}

const styles = (theme: Theme) =>
	createStyles({
		root: {},

		sectionSubtitle: {
			padding: `${theme.spacing.unit}px 0`,
		},

		dropdownLabel: {
			display: 'flex',
			justifyContent: 'flex-end',
			alignItems: 'center',
			paddingTop: '12px',
			[theme.breakpoints.down('sm')]: {
				justifyContent: 'flex-start',
			},
		},
		dropdown: {
			display: 'flex',
			flex: 1,
		},
    block:{
      display: 'block'
    }
	})

export default withStyles(styles)(OtherEnrolledAcademicDetails)
